import Vue from 'vue'
import App from './App.vue'
import router from './router'

import '@/assets/css/bootstrap.min.css'
import '@/assets/css/paper-kit.css?v=2.2.0'
import 'swiper/dist/css/swiper.min.css'

// import 'modernizr'
import '@/assets/js/plugins/modernizr-3.7.1.min.js'
import 'bootstrap/dist/js/bootstrap.bundle'
// import '@/assets/js/plugins/bootstrap-switch.js'
import '@/assets/js/plugins/nouislider.min.js'
// import '@/assets/js/plugins/moment.min.js'
// import '@/assets/js/plugins/bootstrap-datepicker.js'
import '@/assets/js/paper-kit.min.js'

new Vue({
  el: '#app',
  render: h => h(App),
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js